import { createFileRoute } from "@tanstack/react-router"
import LinkedVariantsTab from "~/components/product-management/tabs/LinkedVariantsTab"
import { useProductTableContext } from "~/context/ProductTableProvider"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/linked-variants")({
  component: RouteComponent,
})

function RouteComponent() {
  const { onRowClicked } = useProductTableContext()
  usePageTracking("Product Management Linked Variants")
  if (!onRowClicked) return

  return <LinkedVariantsTab onRowClicked={onRowClicked} />
}
